import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-black text-zinc-400 pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid md:grid-cols-4 gap-12 mb-12">
          {/* Company Info */}
          <div className="md:col-span-2">
            <h3 className="text-2xl font-bold text-white mb-4">ZJF IT Services LLC</h3>
            <p className="text-zinc-400 mb-6 leading-relaxed">
              Professional IT deployment and field services company specializing in workstation rollouts, structured cabling, and network installations across NYC and nationwide.
            </p>
            <div className="space-y-3">
              <div className="flex items-center gap-3">
                <i className="ri-mail-line text-orange-500"></i>
                <a href="mailto:info@zjfitservices.com" className="hover:text-orange-500 transition-colors cursor-pointer">
                  info@zjfitservices.com
                </a>
              </div>
              <div className="flex items-center gap-3">
                <i className="ri-phone-line text-orange-500"></i>
                <a href="tel:973-750-4968" className="hover:text-orange-500 transition-colors cursor-pointer">
                  973-750-4968
                </a>
              </div>
              <div className="flex items-center gap-3">
                <i className="ri-map-pin-line text-orange-500"></i>
                <span>Serving NYC &amp; Nationwide</span>
              </div>
            </div>
            <div className="mt-6 flex items-center gap-4">
              <a
                href="https://www.linkedin.com/company/zjf-it-services/"
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="w-10 h-10 flex items-center justify-center bg-zinc-800 hover:bg-orange-500 rounded-full transition-colors cursor-pointer"
                aria-label="LinkedIn"
              >
                <i className="ri-linkedin-fill text-white text-xl"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-3">
              <li><Link to="/about" className="hover:text-orange-500 transition-colors cursor-pointer">About Us</Link></li>
              <li><Link to="/services" className="hover:text-orange-500 transition-colors cursor-pointer">Services</Link></li>
              <li><Link to="/process" className="hover:text-orange-500 transition-colors cursor-pointer">Process</Link></li>
              <li><Link to="/portfolio" className="hover:text-orange-500 transition-colors cursor-pointer">Our Work</Link></li>
              <li><Link to="/industries" className="hover:text-orange-500 transition-colors cursor-pointer">Industries</Link></li>
              <li><Link to="/contact" className="hover:text-orange-500 transition-colors cursor-pointer">Contact</Link></li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-white font-semibold mb-4">Our Services</h4>
            <ul className="space-y-3">
              <li><Link to="/services" className="hover:text-orange-500 transition-colors cursor-pointer">Workstation Deployments</Link></li>
              <li><Link to="/services" className="hover:text-orange-500 transition-colors cursor-pointer">Structured Cabling</Link></li>
              <li><Link to="/services" className="hover:text-orange-500 transition-colors cursor-pointer">Network Installations</Link></li>
              <li><Link to="/services" className="hover:text-orange-500 transition-colors cursor-pointer">Office IT Relocations</Link></li>
              <li><Link to="/partnership" className="hover:text-orange-500 transition-colors cursor-pointer">MSP Partnership</Link></li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-zinc-800 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-zinc-500">
            © 2020-{currentYear} ZJF IT Services LLC. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <Link to="/privacy-policy" className="text-sm text-zinc-500 hover:text-zinc-400 transition-colors cursor-pointer">
              Privacy Policy
            </Link>
            <Link to="/terms-of-service" className="text-sm text-zinc-500 hover:text-zinc-400 transition-colors cursor-pointer">
              Terms of Service
            </Link>
            <a
              href="https://readdy.ai/?ref=logo"
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="text-sm text-zinc-600 hover:text-zinc-400 transition-colors cursor-pointer"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
